var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWefi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0429EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15589 10.2596C9.15589 10.8549 8.67328 11.3375 8.07795 11.3375C7.48261 11.3375 7 10.8549 7 10.2596C7 9.66425 7.48261 9.18164 8.07795 9.18164C8.67328 9.18164 9.15589 9.66425 9.15589 10.2596Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77655 16.1869H8.4261L7.40454 11.8476C7.61148 11.9355 7.83912 11.9841 8.07812 11.9841C8.54716 11.9841 8.97248 11.7968 9.2834 11.493L9.60581 13.0514L11.8255 9H13.1139L13.8279 12.9427L16.0321 9H18.1897L14.0607 16.1869H12.6637L11.8876 12.4149L9.77655 16.1869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWefi);
export default __webpack_public_path__ + "static/media/wefi.760a2b504abf8b00c6590f10f6b2f095.svg";
export { ForwardRef as ReactComponent };